// ===== 1. Formateadores numéricos =====
export const fmt = (n) =>
  (Number(n) || 0).toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// ===== 2. Rellenar con ceros =====
export const pad = (num, size = 3) => String(num).padStart(size, "0");

// ===== 3. Colores y etiquetas de estado de PO =====
export const formatStatus = (status) => {
  let bg = "#f59e0b";
  let label = "Pendiente";

  switch (status) {
    case "Aprobada":
      bg = "#22c55e";
      label = "Aprobada";
      break;
    case "Cerrada":
      bg = "#000000";
      label = "Cerrada";
      break;
    case "Anulada":
      bg = "#ef4444";
      label = "Anulada";
      break;
    default:
      bg = "#f59e0b";
      label = "Pendiente";
  }

  return { bg, label };
};
